import React, { useState, useEffect } from 'react'
import { useParams, useHistory } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'

import './styles/Person.scss'

import { getPerson } from './redux/action/person'
import { PersonTypes } from './redux/types/person'
import { ApplicationState } from 'AppReducer'

import Modal from 'util/modules/Modal'
import PersonForm from './components/PersonForm'
import PersonList from './components/PersonList'
import ImportContactCsv from './ImportContactCsv'
import ExportContactCSV from './ExportContactCSV'
import DeleteAllContacts from './DeleteAllContacts'
import ValidateContacts from './ValidateContacts'
import { hasPermission } from 'util/services/AuthService'

const Person: React.FC = () => {
  const dispatch = useDispatch()
  const history = useHistory()

  const [isFormOpen, setFormOpen] = useState(false)

  const { id, action } = useParams<{ [x: string]: string }>()

  const { selected } = useSelector((state: ApplicationState) => state.storeReducer)

  function handleFormClose () {
    setFormOpen(false)
    history.push('/panel/person')
  }

  useEffect(() => {
    if (action === 'edit') setFormOpen(true)
  }, [action])

  useEffect(() => {
    if (selected && id) {
      getPerson(selected, id)(dispatch)
    } else {
      dispatch({ type: PersonTypes.PERSON_GET, payload: undefined })
    }
  }, [id, selected])

  return (
    <div className="row panel bordered">
      <div className="person-container row">
        <div className="row padding-24 contact-header">
          <p className="grow" style={{ fontSize: 18 }}>Contatos Cadastrados</p>

          { hasPermission('PERSON:DELETE_ALL') && <DeleteAllContacts /> }
          { hasPermission('PERSON:EXPORT') && <ExportContactCSV /> }
          { hasPermission('PERSON:EXPORT') && <ImportContactCsv /> }

          {
            hasPermission('PERSON:CREATE') &&
            <button className="gradient radius" style={{ width: 120, height: 48 }} onClick={() => setFormOpen(true)}>
              Cadastrar
            </button>
          }
        </div>
        { hasPermission('PERSON:LIST') && <PersonList /> }
        <Modal isOpen={isFormOpen} onClose={handleFormClose}>
          <PersonForm isOpen={isFormOpen} onClose={handleFormClose} />
        </Modal>
      </div>
    </div>
  )
}

export default Person
